import React, { useState, useEffect } from 'react';

import bounceLogo from './bounce-logo.svg';

import './App.css';

import fire from './firebase';

// Icons
import { FaUserPlus, FaMoneyCheckAlt, FaCoffee } from 'react-icons/fa';
import { MdQuestionAnswer } from 'react-icons/md';

var moment = require('moment');

function App() {

  // Declare a new state variable, which we'll call "count"
  const [registrations, setRegistrations] = useState('...');
  const [responses, setResponses] = useState('...');
  const [rewardsPurchased, setRewardsPurchased] = useState('...');
  const [rewardsRedeemed, setRewardsRedeemed] = useState('...');
  const [date, setDate] = useState(new Date());

  // This will only roun on mount and will create listener
  useEffect(() => {
    fire.firestore().collection('dailyMetrics').doc(moment().format('MM-DD-YYYY'))
      .onSnapshot(doc => {
        const metricData = doc.data();

        const {
          registrations,
          responses,
          rewardsPurchased,
          rewardsRedeemed
        } = metricData;

        setRegistrations(registrations);
        setResponses(responses);
        setRewardsPurchased(rewardsPurchased);
        setRewardsRedeemed(rewardsRedeemed);
      })
  }, []);

  useEffect(() => {
    var timerID = setInterval(() => tick(), 1000);

    return function cleanup() {
      clearInterval(timerID);
    };
  })

  // To update the clock timer
  function tick() {
    setDate(new Date());
  }

  return (
    <div className="App">
      <header className="App-header">
        {/* Icon & Clock*/}
        <div className="App-icon-container">
          <img src={bounceLogo} className="App-logo-static" alt="logo" />
          <p className="App-clock">{date.toLocaleTimeString()}</p>
        </div>

        <div className="Stats-row">
          <div className="Stats-item">
            <FaUserPlus size={'2em'} className="Stats-icon" />
            <p className="Stats-title">Registrations</p>
            <p className="Stats-number">{registrations}</p>
          </div>
          <div className="Stats-item">
            <MdQuestionAnswer size={'2em'} className="Stats-icon" />
            <p className="Stats-title">Responses</p>
            <p className="Stats-number">{responses}</p>
          </div>
          <div className="Stats-item">
            <FaMoneyCheckAlt size={'2em'} className="Stats-icon" />
            <p className="Stats-title">Rewards Purchased</p>
            <p className="Stats-number">{rewardsPurchased}</p>
          </div>
          <div className="Stats-item">
            <FaCoffee size={'2em'} className="Stats-icon" />
            <p className="Stats-title">Rewards Redeemed</p>
            <p className="Stats-number">{rewardsRedeemed}</p>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
